function objectAssign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i]
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
          target[key] = source[key]
      }
    }
  }
  return target
}

function stringStartsWith(str, prefix) {
  if (str.length < prefix.length) return false
  for (var i = 0; i < prefix.length; i++) {
    if (str[i] !== prefix[i]) return false
  }
  return true
}

function stringEndsWith(str, postfix) {
  if (str.length < postfix.length) return false
  var offset = postfix.length - str.length
  for (var i = 0; i < postfix.length; i++) {
    if (str[i + offset] !== postfix[i]) return false
  }
  return true
}
var Locator = function (config, location) {
  var _location = location
  var _config = config
  var _cache = {}
  
  function findLocationTemplate (service) {
    for (var i = 0; i < _config.locations.length; i++) {
      var location = _config.locations[i]
      if (location.service && location.service != service) continue
      var regStr = location.location
        .split('.').join('\.')
        .split('*').join('.*')
      regStr = '^' + regStr + '$'
      var reg = new RegExp(regStr)
      if (!reg.test(window.location.origin)) continue
      return location.template
    }
  }

  function getLocationTemplate (location) {
    if (location[location.length - 1] === '/') location = location.substring(0, location.length - 1)
    return location.replace(_config.self, '{name}')
  }

  function getServiceLocation (name) {
    var template =_location
      ? getLocationTemplate(_location)
      : findLocationTemplate(name)
    return template
      .replace('{name}', name)
      .replace('{port}', window.location.port)
  }

  function getServiceLocationCached (name) {
    if (_cache.hasOwnProperty(name)) return _cache[name]
    var location = getServiceLocation(name)
    _cache[name] = location
    return location
  }

  this.getService = function (name) {
    return getServiceLocationCached(name)
  }

  this.getSelf = function () {
    return getServiceLocationCached(_config.self)
  }
}
var EventDispatcher = function (target) {
  var _target = target
  var _listeners

  this.addEventListener = function (type, listener) {
    if (_listeners === undefined) _listeners = {}
    if (_listeners[type] === undefined) _listeners[type] = []
    if (_listeners[type].indexOf(listener) === -1) _listeners[type].push(listener)
  }

  this.removeEventListener = function (type, listener) {
    if (_listeners === undefined) return
    if (_listeners[type] === undefined) return
    var index = _listeners[type].indexOf(listener)
    if (index !== -1) _listeners[type].splice(index, 1)
  }

  this.dispatchEvent = function (event) {
    if (_listeners === undefined) return
    if (_listeners[event.type] === undefined) return
    var listeners = _listeners[event.type].slice(0)
    for (var i = 0, l = listeners.length; i < l; i++) {
      listeners[i].call(this, event)
    }
  }
}
var EventRedirector = function (events) {
  var _events = events
  var _instance
  var _proxy

  function eventHandler (event) {
    _proxy.dispatchEvent(event)
  }

  this.init = function (instance, proxy) {
    if (_instance) throw new Error('init can be invoked only one time')
    _instance = instance
    _proxy = proxy
    for (var i = 0; i < _events.length; i++) {
      _instance.addEventListener(_events[i], eventHandler)
    }
  }

  this.destroy = function () {
    if (!_instance) return
    for (var i = 0; i < _events.length; i++) {
      _instance.removeEventListener(_events[i], eventHandler)
    }
  }
}
var MethodRedirector = function (methods) {
  var _methods = methods
  var _instance
  var _proxy

  function getProxyMethod (name) {
    return function () {
        try {
          var args = [].slice.call(arguments)
          if (typeof _instance[name] !== 'function') throw new Error(name + ' is not a function')
          var result = _instance[name].apply(_instance, args)
          if (result instanceof Promise) return result
          else return Promise.resolve(result)
        } catch (error) {
          return Promise.reject(error)
        }
    }
  }

  this.init = function (instance, proxy) {
    if (_instance) throw new Error('init can be invoked only one time')
    _instance = instance
    _proxy = proxy
    for (var i = 0; i < _methods.length; i++) {
      var methodName = _methods[i]
      var proxyMethod = getProxyMethod(methodName)
      _proxy[methodName] = proxyMethod
    }
  }

  this.destroy = function () {
    if (!_instance) return
    for (var i = 0; i < _methods.length; i++) {
      var methodName = _methods[i]
      delete _proxy[methodName]
    }
  }
}
var Redirector = function (options, params) {
  var _manager = new FrameManager(options.locatorConfig, params.settings)

  this.init = function () {
    var url = _manager.getUrl()
    window.location = url
  }
}
var WidgetInstanceWrapper = function (options, params) {
  objectAssign(this, new EventDispatcher(this))

  var _self = this
  var _options = options
  var _params = params
  var _instance
  var _methodRedirector = new MethodRedirector(_options.methods)
  var _eventRedirector = new EventRedirector(_options.events)

  this.init = function (widget) {
    if (document.querySelector(_params.selector) === null) throw new Error('Can not find "' + _params.selector + '"')
    _instance = widget.init(_params.selector, _params.settings)
    _methodRedirector.init(_instance, _self)
    _eventRedirector.init(_instance, _self)
  }

  this.destroy = function () {
    if (!_instance) return
    _eventRedirector.destroy()
    _methodRedirector.destroy()
    _instance.destroy()
  }
}
var WidgetWrapper = function (options) {
  var _options = options

  var _host

  var _loadingCounter = 0
  var _usageCounter = 0
  var _loading = undefined

  function getJsonpFunction() {
    return window[_options.objects[0]]
  }

  function loaded (e) {
    if (!_loading) return

    if (+e.target.getAttribute('data-loading-id') !== _loading.id) return

    if (e.target.tagName === 'SCRIPT'
      && ++_loading.scriptsLoaded < _loading.assets.scripts.length) {
      console.log('ww.loaded src=', e.target.src)
      loadScript(_loading.assets.scripts[_loading.scriptsLoaded], _loading.id)
    }
    
    // Uncaught TypeError: Cannot read properties of undefined (reading 'styles')
    if (++_loading.assetsLoaded === _loading.assets.styles.length + _loading.assets.scripts.length) {
      console.log('ww.loaded resolvesLength=', _loading.resolves.length)
      _loading.resolves.forEach(function (resolve) {
        resolve(getJsonpFunction())
      })
      _loading = undefined
    }
  }

  function getAssetsJson () {
    var url = _host + '/assets.json?v=' + new Date().getTime()
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest()
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return
        if (xhr.status !== 200) {
          console.error('Can not get asserts.json (' + xhr.status + ': ' + xhr.statusText + ')')
        } else {
          resolve(xhr.responseText)
        }
      }
      xhr.open('GET', url, true)
      xhr.setRequestHeader('Cache-Control', 'no-cache')
      xhr.send()
    })
  }

  function loadScript (url, loadingId) {
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = _host + url
    script.setAttribute('data-loading-id', loadingId)
    script.onload = loaded
    document.getElementsByTagName('head')[0].appendChild(script)
    console.log('ww.loadScript ', _host + url)
  }

  function loadStyle (url, loadingId) {
    var link = document.createElement('link')
    link.href = _host + url
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.setAttribute('data-loading-id', loadingId)
    link.onload = loaded
    document.getElementsByTagName('head')[0].appendChild(link)
  }

  function clear(removeSelf) {
    var scripts = document.querySelectorAll('script[src^="' + _host + '"]')
    scripts.forEach(function (script) {
      if (stringEndsWith(script.src, _options.filename) && !removeSelf) return
      console.log('ww.clear script ', script.src)
      script.remove()
    })

    var links = document.querySelectorAll('link[href^="' + _host + '"]')
    links.forEach(function (link) {
      link.remove()
    })
    
    _options.objects.forEach(function (obj) {
      if (window[obj] !== undefined) delete window[obj]
    })
    if (removeSelf && window[_options.name] !== undefined) delete window[_options.name]

  }

  function load () {
    return new Promise(function (resolve, reject) {
      var loadingId = _loadingCounter
      if (!_loading) {
        loadingId = ++_loadingCounter
        console.log('ww.load new load', 'loadingId=', loadingId)
        _loading = {
          id: loadingId,
          resolves: [],
          rejectes: [],
          assets: undefined,
          assetsLoaded: 0,
          scriptsLoaded: 0,
        }
      }

      var needLoad = _usageCounter++ === 0
      _loading.resolves.push(resolve)
      _loading.rejectes.push(reject)

      if (needLoad) {
        getAssetsJson().then(function (content) {
          if (!_loading) return
          console.log('ww.load assets loaded', '_loading.id=', _loading.id, 'loadingId=',loadingId)
          if (_loading.id !== loadingId) return
          _loading.assets = JSON.parse(content)
          _loading.assets.styles.forEach(function (styleUrl) {
            loadStyle(styleUrl, _loading.id)
          })
  
          loadScript(_loading.assets.scripts[0], _loading.id)
        })
      }
    })
  }

  function createInstance(params) {
    var instanceWrapper = new WidgetInstanceWrapper(_options, params)
    load().then(function (widget) {
      instanceWrapper.init(widget)
    })
    return instanceWrapper
  }

  function createInstanceAsync(params) {
    return new Promise(function (resolve, reject) {
      var instanceWrapper = new WidgetInstanceWrapper(_options, params)
      console.log('ww.createInstanceAsync loading')
      load()
        .then(function (widget) {
          console.log('ww.createInstanceAsync loaded ', getJsonpFunction())
          if (!getJsonpFunction()) {
            createInstanceAsync(params)
              .then(function (iw) {
                resolve(iw)
              })
          }
          else
          {
            console.log('ww.createInstanceAsync instancewrapper.init')
            instanceWrapper.init(widget)
            resolve(instanceWrapper)
          }
        })
        .catch(function (err) {
          console.log('ww.createInstanceAsync reject')
          reject(err)
        })
    })
  }

  function makeRedirect(params) {
    new Redirector(_options, params).init()
  }

  this.init = function (selector, settings) {
    _host = new Locator(_options.locatorConfig, settings.location).getSelf()
    var params = {
      selector: selector,
      settings: settings
    }
    if (selector != undefined) return createInstance(params)
    return makeRedirect(params)
  }

  this.initAsync = function (selector, settings) {
    console.log('ww.initAsync', selector)
    return new Promise(function (resolve, reject) {
      _host = new Locator(_options.locatorConfig, settings.location).getSelf()
      var params = {
        selector: selector,
        settings: settings
      }
      if (selector != undefined) {
        createInstanceAsync(params)
          .then(function (widget) {
            resolve(widget)
          })
          .catch(function (err) {
            console.log('ww.initAsync reject')
            reject(err)
          })
      }
      else resolve(makeRedirect(params))
    })
  }

  this.sweep = function (removeSelf) {
    console.log('ww.sweep started usageCounter=', _usageCounter)
    if (--_usageCounter > 0) return
    if (_loading) {
      _loading.rejectes.forEach(function (reject) {
        console.log('ww.sweep reject')
        reject(new Error('Loading rejected'))
      })
    }
    _loading = undefined
    clear(removeSelf)
    console.log('ww.sweep done')
  }
}

var options = {
  "filename":"widget.js",
  "name":"bkWidget",
  "locatorConfig":{
    "self":"player-widget-a",
    "locations":[
      {"location":"http://*.book.internal","template":"http://{name}.book.internal"},
      {"location":"http://*.book.internal:*","template":"http://{name}.book.internal:{port}"},
      {"location":"http://localhost:*","template":"http://{name}.lbltest.ru"},
      {"location":"http://local.host:*","template":"https://{name}.lbltest.ru"},
      {"location":"http://*.lbltest.ru","template":"http://{name}.lbltest.ru"},
      {"location":"https://*.lbltest.ru","template":"https://{name}.lbltest.ru"},
      {"location":"https://*.bet777.tk","template":"https://{name}.lbltest.ru"},
      {"location":"https://*.mbk777.gq","template":"https://{name}.lbltest.ru"},
      {"location":"https://*.mktest.xyz","template":"https://{name}.lbltest.ru"},
      {"location":"https://*.betngo.org","template":"https://{name}.lbltest.ru"},
      {"location":"http://test.flg.bet","template":"https://{name}.lbltest.ru"},
      {"location":"https://cashier.mbktest.com","template":"https://{name}.lbltest.ru"},
      {"location":"*","template":"https://{name}.livebetline.com"}
    ],
    "configs":{
      "test":{
        "self":"player-widget-a",
        "locations":[{"location":"*","template":"https://{name}.lbltest.ru"}]
      },
      "prod":{
        "self":"player-widget-a",
        "locations":[{"location":"*","template":"https://{name}.livebetline.net"}]
      }
    }
  },
  "objects":["bkWidgetInternal","bkWidgetJsonpFunction"],
  "events":["ready","showed","resize","login","betted","orderDisplay","orderEnabled","ordered","jump","hop","scroll","monitor","printed"],
  "methods":["set","more","scroll","order"]
}

export default new WidgetWrapper(options)


// WEBPACK FOOTER //
// ./_common/services/bk.widget.service.js